import { Button, IconButton, Tooltip } from '@material-ui/core';
import { ArrowBack, Info } from '@material-ui/icons';
import CancelIcon from '@material-ui/icons/Cancel';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NetworkWifiIcon from '@mui/icons-material/NetworkWifi';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import UiBuilderCommonComponent from '../../../../components/ui-builder/UiBuilder-Common-Component';
import {
  ACCORDION_WO_ICON,
  ACCORDION_W_ICON,
  BUTTON_W_CTA,
  BUTTON_W_ICON,
  CAROUSEL_LANDSCAPE_W_BG,
  CAROUSEL_LANDSCAPE_W_BODY_CTA,
  CAROUSEL_LARGE_IMG_W_BG,
  CAROUSEL_PORTRAIT_W_BG,
  CAROUSEL_SOCIAL,
  CAROUSEL_WO_BG,
  DETAIL_PAGE,
  FLOW_MAPPING,
  HERO_BANNER_W_CTA,
  HERO_BANNER_W_SUBTITLE_CTA,
  HERO_BANNER_W_TITLE,
  IMAGE_LARGE,
  IMAGE_LARGE_W_BG,
  IMAGE_LARGE_W_TITLE_BODY,
  IMAGE_LARGE_W_TITLE_SUBTITLE_BODY,
  IMAGE_W_TITLE_BODY,
  LIST_COMPONENT,
  SERVICE_DETAIL_COMPONENT,
  SMALL_BANNER_W_TITLE,
  BASIC_TEXT_COMPONENT,
  CAROUSEL_W_DESCRIPTION,
} from '../../../../constants/UiBuilderConst';
import DeletePopupModel from '../../../../shared/delete-popup/Delete-Popup';
import { validateEmail, validateUrl } from '../../../../utils/formUtils';
import { isAllowedExternalUrl } from '../../../../utils/urlValidationUtils';
import { notificationManager } from '../../../../utils/NotificationUtils';
import {
  saveUiBuilderPageConfigs,
  publishUiBuilderPage,
} from '../../../../utils/UiBuilderAPIUtils';
import { getUniqueID } from '../../../../utils/UiBuilderUtils';
import { fetchAllUIBuilderPages } from '../../../property/propertySlice';
import PageBuilderLibrary from './Page-Builder-Library';
import PageBuilderPreview from './Page-Builder-Preview';
import './Page-Builder.scss';
import {
  allAmenitiesSelector,
  allRestaurantSelector,
  allRoomTypesSelector,
  allSpaInfoSelector,
} from '../../../../layouts/property/propertySlice';
import { offerSelector } from '../../../../layouts/cms/cmsSlice';
import { decryptLocalStorage } from '../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../utils/loaderSlice';

const UiBuilderPageBuilder = (props) => {
  const { page, onViewToggle, hotelId, groupId, showLoader = () => {} } = props;
  const [showLibrary, setShowLibrary] = useState(false);
  const [componentsList, setComponentsList] = useState([]);
  const [handleError, setHandleError] = useState([]);
  const [deleteComponent, setDeleteComponent] = useState({ status: false });
  const [isAddLine, setIsAddLine] = useState(false);
  const [componentExpandStatus, setComponentExpandStatus] = useState([]);
  const maxCompLimit = 25;
  const dispatch = useDispatch();
  const allRestaurantoptions = useSelector(allRestaurantSelector);
  const allSpaOptions = useSelector(allSpaInfoSelector);
  const allRoomsOptions = useSelector(allRoomTypesSelector);
  const allAmenitiesOptions = useSelector(allAmenitiesSelector);
  const allOffers = useSelector(offerSelector);

  useEffect(() => {
    if (page.uiConfiguration !== '') {
      const tempCompList = JSON.parse(page.uiConfiguration).map((e) => {
        return {
          ...e,
          uuxid: getUniqueID(),
        };
      });

      let temp = tempCompList.filter((comp) => {
        if (
          comp?.config &&
          comp?.config.slides &&
          comp?.config.slides.length > 0 &&
          comp?.config.hotelModule &&
          comp?.id !== IMAGE_W_TITLE_BODY
        ) {
          let optionsList = [];
          switch (comp?.config.hotelModule) {
            case 'ROOMS':
              optionsList = allRoomsOptions.filter((item) => item.isActive);
              break;
            case 'RESTAURANT':
              optionsList = allRestaurantoptions.filter((item) => item.isActive);
              break;
            case 'WELLNESS':
              optionsList = allSpaOptions.filter((item) => item.isActive);
              break;
            case 'EXPERIENCES':
              optionsList = [];
              break;
            case 'AMENITY':
              optionsList = allAmenitiesOptions.filter((item) => item.isActive);
              break;
            case 'OFFERS':
              optionsList = allOffers.filter((item) => item.status === 'Live');
              break;
            default:
              optionsList = [];
              break;
          }

          if (optionsList.length > 0) {
            const filteredSlides = comp?.config?.slides.filter(
              (slide) =>
                slide.hotelModuleId === '' ||
                optionsList.some((item) => item.id === slide.hotelModuleId),
            );

            comp.config.slides = filteredSlides;
            if (filteredSlides.length === 0) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        } else {
          return true;
        }
      });
      setComponentsList(temp);
      setComponentExpandStatus(temp.map((comp) => true));
    }
  }, [page.uiConfiguration]);

  const onComponentDrop = (e) => {
    if (componentsList.length < maxCompLimit) {
      const component = JSON.parse(e.dataTransfer.getData('component'));
      const currComponentsList = [...componentsList];
      currComponentsList.push({
        title: component.componentTitle ? component.componentTitle : component.title,
        id: component.id,
        uuxid: getUniqueID(),
        config: {},
      });
      setComponentsList(currComponentsList);

      const currComponentExpandStatus = [...componentExpandStatus];
      currComponentExpandStatus.push(true);
      setComponentExpandStatus(currComponentExpandStatus);
    } else {
      notificationManager('danger', 'Maximum limit of Components reached');
    }
  };

  const onComponentragOver = (e) => {
    e.preventDefault();
  };

  const onComponentChange = (e, index) => {
    let currComponentsList = componentsList.map((item, i) => {
      if (index === i) {
        return { ...item, config: e.config };
      } else {
        return item;
      }
    });
    setComponentsList(currComponentsList);
  };

  const handleClose = () => {
    setDeleteComponent({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      item: null,
      index: -1,
    });
  };

  const handleDeletePopupOpen = (index) => {
    setDeleteComponent({
      index: index,
      name: 'this component',
      title: 'Are you sure you want to remove',
      description: 'This action cannot be reversed.',
      status: true,
    });
  };

  const onClickDelete = () => {
    try {
      dispatch(stepUpLoaderCount());
      const currComponentsList = [...componentsList];
      currComponentsList.splice(deleteComponent.index, 1);
      setComponentsList(currComponentsList);
      const currComponentExpandStatus = [...componentExpandStatus];
      currComponentExpandStatus.splice(deleteComponent.index, 1);
      setComponentExpandStatus(currComponentExpandStatus);
      notificationManager('success', 'Component removed');
      handleClose();
    } catch (error) {
      if (error?.graphQLErrors) {
        notificationManager('danger', error?.graphQLErrors?.[0]?.message);
      } else {
        notificationManager('danger', 'Error while deleting component.');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const onClickDuplicate = (component) => {
    if (componentsList.length < maxCompLimit) {
      const currComponentsList = [...componentsList];
      const duplicatedComponent = JSON.parse(JSON.stringify(component));
      duplicatedComponent.uuxid = getUniqueID();
      currComponentsList.push(duplicatedComponent);
      setComponentsList(currComponentsList);
    } else {
      notificationManager('danger', 'Maximum limit of Components reached');
    }
  };

  const checkComponentField = () => {
    const deepTrim = (v) => {
      if (typeof v === 'string') return v?.trim();
      if (Array?.isArray(v)) return v?.map(deepTrim);
      if (v && typeof v === 'object')
        return Object?.fromEntries(Object?.entries(v)?.map(([k, val]) => [k, deepTrim(val)]));
      return v;
    };
    const sanitizedComponentsList = componentsList?.map((c) => deepTrim({ ...c }));
    const componentsError = sanitizedComponentsList?.map((listValue, listNdx) => {
      let configError = {};
      if (!listValue.config.hotelModule) {
        if (
          listValue.id === BASIC_TEXT_COMPONENT &&
          (!listValue.config.text || listValue.config.text === '')
        ) {
          configError = {
            ...configError,
            text: 'required',
          };
        }
        if (listValue.id === BASIC_TEXT_COMPONENT && !listValue.config.textType) {
          configError = {
            ...configError,
            textType: 'required',
          };
        }
        if (
          listValue.id === BASIC_TEXT_COMPONENT &&
          listValue.config.textPadding &&
          listValue.config.textPadding?.paddingTop === 0
        ) {
          configError = {
            ...configError,
            paddingTop: 'oneToFive',
          };
        }
        if (
          listValue.id === BASIC_TEXT_COMPONENT &&
          listValue.config.textPadding &&
          listValue.config.textPadding?.paddingBottom === 0
        ) {
          configError = {
            ...configError,
            paddingBottom: 'oneToFive',
          };
        }
        if (
          (listValue.id === IMAGE_W_TITLE_BODY ||
            listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
            listValue.id === IMAGE_LARGE_W_BG ||
            listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
          listValue.config.titleH1 === ''
        )
          configError = {
            ...configError,
            titleH1: 'required',
          };
        if (
          (listValue?.id === CAROUSEL_PORTRAIT_W_BG ||
            listValue?.id === CAROUSEL_LANDSCAPE_W_BG ||
            listValue?.id === CAROUSEL_W_DESCRIPTION ||
            listValue?.id === CAROUSEL_WO_BG ||
            listValue?.id === CAROUSEL_SOCIAL ||
            listValue?.id === BUTTON_W_ICON) &&
          listValue?.config?.titleH2 === ''
        )
          configError = {
            ...configError,
            titleH2: 'required',
          };

        if (listValue?.id === CAROUSEL_LARGE_IMG_W_BG && listValue?.config?.imgMain?.titleH2 === '')
          configError = {
            ...configError,
            titleH2: 'required',
          };
        if (
          (listValue?.id === IMAGE_LARGE_W_BG ||
            listValue?.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
          listValue?.config?.titleH3 === ''
        )
          configError = {
            ...configError,
            titleH3: 'required',
          };
      }
      if (
        (listValue.id === DETAIL_PAGE || listValue.id === LIST_COMPONENT) &&
        listValue.config.hotelModule === ''
      )
        configError = {
          ...configError,
          hotelModule: 'required',
        };
      if (listValue.id === DETAIL_PAGE && listValue.config.hotelModuleId === '')
        configError = {
          ...configError,
          hotelModuleId: 'required',
        };
      if (
        (listValue.id === IMAGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_BG ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
        listValue?.config?.titleH1 === ''
      )
        configError = {
          ...configError,
          titleH1: 'required',
        };
      if (
        listValue?.id === SERVICE_DETAIL_COMPONENT &&
        listValue?.config?.isTitleActive &&
        listValue?.config?.titleH2 === ''
      )
        configError = {
          ...configError,
          titleH2: 'required',
        };
      if (
        (listValue.id === IMAGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === SERVICE_DETAIL_COMPONENT ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
        listValue?.config?.body === ''
      )
        configError = {
          ...configError,
          body: 'required',
        };
      if (
        (listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_BG ||
          listValue.id === IMAGE_LARGE ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
        !listValue.config?.isVideo &&
        !listValue.config.imgURL
      )
        configError = {
          ...configError,
          imgURL: 'required',
        };
      if (
        (listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_BG ||
          listValue.id === IMAGE_LARGE ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
        listValue.config?.isVideo &&
        !listValue.config.videoURL
      )
        configError = {
          ...configError,
          videoURL: 'required',
        };
      if (
        (listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_BG ||
          listValue.id === IMAGE_LARGE ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY) &&
        listValue.config?.isVideo &&
        listValue.config.videoURL &&
        (!validateUrl(listValue.config.videoURL) || !isAllowedExternalUrl(listValue.config.videoURL))
      )
        configError = {
          ...configError,
          videoURL: !validateUrl(listValue.config.videoURL) ? 'validUrl' : 'safeDomain',
        };
      if (
        (listValue?.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue?.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY ||
          listValue?.id === SERVICE_DETAIL_COMPONENT ||
          listValue?.id === BUTTON_W_CTA) &&
        listValue?.config?.cta?.isActive &&
        !listValue?.config?.cta?.title
      )
        configError = {
          ...configError,
          CTA: 'required',
        };
      if (
        (listValue.id === CAROUSEL_PORTRAIT_W_BG ||
          listValue.id === CAROUSEL_LANDSCAPE_W_BG ||
          listValue.id === CAROUSEL_W_DESCRIPTION ||
          listValue.id === CAROUSEL_SOCIAL ||
          listValue.id === CAROUSEL_LANDSCAPE_W_BODY_CTA ||
          listValue.id === CAROUSEL_WO_BG ||
          listValue.id === CAROUSEL_LARGE_IMG_W_BG) &&
        listValue.config?.viewAll?.isActive &&
        !listValue.config?.viewAll?.linkId
      )
        configError = {
          ...configError,
          viewAll: 'required',
        };
      if (
        (listValue.id === IMAGE_LARGE_W_TITLE_BODY ||
          listValue.id === IMAGE_LARGE_W_BG ||
          listValue.id === IMAGE_LARGE ||
          listValue.id === SERVICE_DETAIL_COMPONENT ||
          listValue.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY ||
          listValue.id === BUTTON_W_CTA) &&
        listValue.config?.redirectLink?.isActive &&
        (!listValue.config?.redirectLink?.connection || !listValue.config?.redirectLink?.linkId)
      )
        configError = {
          ...configError,
          redirect: 'required',
        };
      if (
        (listValue.id === SERVICE_DETAIL_COMPONENT || listValue.id === BUTTON_W_CTA) &&
        listValue.config?.redirectLink?.isActive &&
        listValue.config?.redirectLink?.connection === 'FLOW' &&
        FLOW_MAPPING.hasOwnProperty(listValue.config?.redirectLink?.linkId) &&
        !listValue.config?.redirectLink?.flowSubSelection
      ) {
        configError = {
          ...configError,
          redirect: 'required',
        };
      }

      if (
        listValue.config?.redirectLink?.isActive &&
        listValue.config?.redirectLink?.connection === 'EXTERNAL' &&
        !validateUrl(listValue.config.redirectLink.linkId)
      ) {
        configError = {
          ...configError,
          redirect: 'validUrl',
        };
      }

      if (
        listValue.id === CAROUSEL_LARGE_IMG_W_BG &&
        listValue.config?.imgMain?.isVideo &&
        listValue.config?.imgMain?.videoURL &&
        (!validateUrl(listValue.config?.imgMain?.videoURL) || !isAllowedExternalUrl(listValue.config?.imgMain?.videoURL))
      )
        configError = {
          ...configError,
          videoURL: !validateUrl(listValue.config?.imgMain?.videoURL) ? 'validUrl' : 'safeDomain',
        };
      if (
        listValue.id === CAROUSEL_LARGE_IMG_W_BG &&
        !listValue.config?.imgMain?.isVideo &&
        !listValue.config?.imgMain?.imgURL
      )
        configError = {
          ...configError,
          imgURL: 'required',
        };
      if (
        listValue.id === CAROUSEL_LARGE_IMG_W_BG &&
        listValue.config?.imgMain?.isVideo &&
        !listValue.config?.imgMain?.videoURL
      )
        configError = {
          ...configError,
          videoURL: 'required',
        };
      if (
        listValue.id === CAROUSEL_LARGE_IMG_W_BG &&
        listValue.config.imgMain.redirectLink.isActive &&
        (listValue.config.imgMain.redirectLink.connection === '' ||
          listValue.config.imgMain.redirectLink.linkId === '')
      )
        configError = {
          ...configError,
          redirect: 'required',
        };
      if (
        listValue.id === SERVICE_DETAIL_COMPONENT &&
        listValue.config.phone.isActive &&
        listValue.config.phone.number === ''
      )
        configError = {
          ...configError,
          phone: 'required',
        };
      if (
        listValue.id === SERVICE_DETAIL_COMPONENT &&
        listValue.config.email.isActive &&
        listValue.config.email.address === ''
      )
        configError = {
          ...configError,
          email: 'required',
        };
      if (
        listValue.id === SERVICE_DETAIL_COMPONENT &&
        listValue.config.email.isActive &&
        !validateEmail(listValue.config.email.address)
      )
        configError = {
          ...configError,
          email: 'validEmail',
        };
      if (listValue.id === SERVICE_DETAIL_COMPONENT) {
        const images = listValue.config?.images?.map((imageValue, imagePos) => {
          let imageError = {};
          if (!imageValue?.isVideo && !imageValue?.imgURL)
            imageError = {
              ...imageError,
              imgURL: 'required',
              pos: imagePos,
            };
          if (imageValue?.isVideo && !imageValue?.videoURL)
            imageError = {
              ...imageError,
              videoURL: 'required',
              pos: imagePos,
            };
          if (imageValue?.isVideo && imageValue?.videoURL && (!validateUrl(imageValue?.videoURL) || !isAllowedExternalUrl(imageValue?.videoURL)))
            imageError = {
              ...imageError,
              videoURL: !validateUrl(imageValue?.videoURL) ? 'validUrl' : 'safeDomain',
              pos: imagePos,
            };
          if (Object.keys(imageError).length > 0) return imageError;
        });
        const highLights = listValue.config?.highLights?.highLightList?.map(
          (highLightKey, highLightPos) => {
            let highLightError = {};
            if (listValue.id === SERVICE_DETAIL_COMPONENT && !highLightKey.highLight)
              highLightError = {
                ...highLightError,
                highLight: 'required',
                pos: highLightPos,
              };
            if (Object.keys(highLightError).length > 0) return highLightError;
          },
        );
        const filterImageError = images?.filter((e) => e !== undefined);
        const filterHighLightError = highLights?.filter((e) => e !== undefined);
        if (
          filterImageError?.length > 0 ||
          (filterHighLightError?.length > 0 && listValue.config?.highLights?.isActive) ||
          Object.keys(configError).length > 0
        ) {
          return {
            images: filterImageError ?? [],
            highLights: filterHighLightError ?? [],
            pos: listNdx,
            id: listValue.id,
            config: configError,
          };
        }
      } else if (listValue.id === ACCORDION_W_ICON || listValue.id === ACCORDION_WO_ICON) {
        const accordions = listValue.config?.accordions?.map((accordionValue, accordionPos) => {
          let accordionsError = {};
          if (listValue.id === ACCORDION_W_ICON && !accordionValue.imgURL)
            accordionsError = {
              ...accordionsError,
              imgURL: 'required',
              pos: accordionPos,
            };
          if (
            (listValue?.id === ACCORDION_W_ICON || listValue?.id === ACCORDION_WO_ICON) &&
            !accordionValue?.titleH3
          )
            accordionsError = {
              ...accordionsError,
              titleH3: 'required',
              pos: accordionPos,
            };
          if (
            (listValue.id === ACCORDION_W_ICON || listValue.id === ACCORDION_WO_ICON) &&
            !accordionValue?.body
          )
            accordionsError = {
              ...accordionsError,
              body: 'required',
              pos: accordionPos,
            };
          if (Object.keys(accordionsError).length > 0) return accordionsError;
        });
        const filterAccordionsError = accordions?.filter((e) => e !== undefined);
        if (filterAccordionsError.length || Object.keys(configError).length > 0)
          return {
            accordions: filterAccordionsError ?? [],
            pos: listNdx,
            id: listValue.id,
            config: configError,
          };
      } else if (listValue.id === LIST_COMPONENT) {
        const listItems = listValue.config?.listItems?.map((itemValue, itemPos) => {
          let listItemsError = {};
          if (listValue.id === LIST_COMPONENT && !itemValue.hotelModuleId)
            listItemsError = {
              ...listItemsError,
              hotelModuleId: 'required',
              pos: itemPos,
            };
          if (Object.keys(listItemsError).length > 0) return listItemsError;
        });
        const filterListItemsError = listItems?.filter((e) => e !== undefined);
        if (filterListItemsError.length || Object.keys(configError).length > 0)
          return {
            listItems: filterListItemsError ?? [],
            pos: listNdx,
            id: listValue.id,
            config: configError,
          };
      } else if (listValue.id === BUTTON_W_ICON) {
        const slides = listValue.config?.button?.map((slidesValue, slidesPos) => {
          let slidesError = {};
          if (!slidesValue.leftIconImgURL && !slidesValue.leftIconHide) {
            slidesError = {
              ...slidesError,
              leftIconImgURL: 'required',
              pos: slidesPos,
            };
          }

          if (!slidesValue.rightIconImgURL && !slidesValue.rightIconHide) {
            slidesError = {
              ...slidesError,
              rightIconImgURL: 'required',
              pos: slidesPos,
            };
          }

          if (!slidesValue?.buttonTitle)
            slidesError = {
              ...slidesError,
              buttonTitle: 'required',
              pos: slidesPos,
            };

          if (
            slidesValue?.redirectLink[0]?.isActive &&
            (!slidesValue?.redirectLink[0]?.connection || !slidesValue?.redirectLink[0]?.linkId)
          )
            slidesError = {
              ...slidesError,
              redirect: 'required',
              pos: slidesPos,
            };
          if (
            slidesValue?.redirectLink[0]?.isActive &&
            slidesValue?.redirectLink[0]?.connection === 'EXTERNAL' &&
            !validateUrl(slidesValue?.redirectLink[0]?.linkId)
          ) {
            slidesError = {
              ...slidesError,
              redirect: 'validUrl',
              pos: slidesPos,
            };
          }
          if (
            slidesValue?.redirectLink[0]?.isActive &&
            slidesValue?.redirectLink[0]?.connection === 'EXTERNAL' &&
            !slidesValue?.redirectLink[0]?.linkId
          ) {
            slidesError = {
              ...slidesError,
              redirect: 'required',
              pos: slidesPos,
            };
          }

          if (Object.keys(slidesError).length > 0) return slidesError;
        });
        const filterSlidesError = slides?.filter((e) => e !== undefined);
        if (filterSlidesError?.length || Object.keys(configError).length > 0)
          return {
            slides: filterSlidesError ?? [],
            pos: listNdx,
            id: listValue.id,
            config: configError,
          };
      } else {
        const slides = listValue.config?.slides?.map((slidesValue, slidesPos) => {
          let slidesError = {};
          if (!slidesValue.isVideo && !slidesValue.imgURL) {
            slidesError = {
              ...slidesError,
              imgURL: 'required',
              pos: slidesPos,
            };
          }
          if (slidesValue.isVideo && !slidesValue.videoURL) {
            slidesError = {
              ...slidesError,
              videoURL: 'required',
              pos: slidesPos,
            };
          }

          if (slidesValue.isVideo && slidesValue.videoURL && (!validateUrl(slidesValue?.videoURL) || !isAllowedExternalUrl(slidesValue?.videoURL))) {
            slidesError = {
              ...slidesError,
              videoURL: !validateUrl(slidesValue?.videoURL) ? 'validUrl' : 'safeDomain',
              pos: slidesPos,
            };
          }
          if (!slidesValue.hotelModuleId) {
            if (
              (listValue?.id === HERO_BANNER_W_CTA ||
                listValue?.id === HERO_BANNER_W_SUBTITLE_CTA) &&
              !slidesValue?.titleH1
            )
              slidesError = {
                ...slidesError,
                titleH1: 'required',
                pos: slidesPos,
              };
            if (
              (listValue?.id === HERO_BANNER_W_TITLE ||
                listValue?.id === SMALL_BANNER_W_TITLE ||
                listValue?.id === CAROUSEL_LANDSCAPE_W_BODY_CTA) &&
              !slidesValue?.titleH2
            )
              slidesError = {
                ...slidesError,
                titleH2: 'required',
                pos: slidesPos,
              };
            if (
              (listValue?.id === HERO_BANNER_W_SUBTITLE_CTA ||
                listValue?.id === CAROUSEL_WO_BG ||
                listValue?.id === CAROUSEL_LARGE_IMG_W_BG ||
                listValue?.id === IMAGE_W_TITLE_BODY ||
                listValue?.id === CAROUSEL_W_DESCRIPTION) &&
              !slidesValue?.titleH3
            ) {
              slidesError = {
                ...slidesError,
                titleH3: 'required',
                pos: slidesPos,
              };
            }
          }
          if (listValue.id === CAROUSEL_WO_BG && listValue?.config?.isIconActive) {
            const icons = slidesValue?.icon?.iconList
              ?.map((iconSlide, iconPos) => {
                let iconSlidesError = {};
                if (!iconSlide.imgURL && !iconSlide.isHide)
                  iconSlidesError = {
                    ...iconSlidesError,
                    imgURL: 'required',
                    pos: iconPos,
                  };

                if (!iconSlide.titleH4 && !iconSlide.isHide)
                  iconSlidesError = {
                    ...iconSlidesError,
                    titleH4: 'required',
                    pos: iconPos,
                  };

                if (Object.keys(iconSlidesError).length > 0) return iconSlidesError;
              })
              .filter((x) => x !== undefined);
            if (icons.length > 0) {
              slidesError = {
                ...slidesError,
                pos: slidesPos,
                icon: icons,
              };
            }
          }
          if (listValue?.id === CAROUSEL_LANDSCAPE_W_BODY_CTA && slidesValue?.body === '')
            slidesError = {
              ...slidesError,
              body: 'required',
              pos: slidesPos,
            };

          if (
            (listValue.id === HERO_BANNER_W_CTA ||
              listValue.id === HERO_BANNER_W_SUBTITLE_CTA ||
              listValue.id === HERO_BANNER_W_TITLE ||
              listValue.id === SMALL_BANNER_W_TITLE ||
              listValue.id === CAROUSEL_PORTRAIT_W_BG ||
              listValue.id === CAROUSEL_LANDSCAPE_W_BG ||
              listValue.id === CAROUSEL_W_DESCRIPTION ||
              listValue.id === CAROUSEL_WO_BG ||
              listValue.id === CAROUSEL_LARGE_IMG_W_BG ||
              listValue.id === IMAGE_W_TITLE_BODY ||
              listValue.id === CAROUSEL_LANDSCAPE_W_BODY_CTA) &&
            slidesValue?.redirectLink?.isActive &&
            (!slidesValue?.redirectLink?.connection || !slidesValue?.redirectLink?.linkId)
          )
            slidesError = {
              ...slidesError,
              redirect: 'required',
              pos: slidesPos,
            };
          if (listValue.id === CAROUSEL_W_DESCRIPTION && !slidesValue.titleH3) {
            slidesError = {
              ...slidesError,
              redirect: 'required',
              titleH3: 'required',
              pos: slidesPos,
            };
          }
          if (
            slidesValue?.redirectLink?.isActive &&
            slidesValue?.redirectLink?.connection === 'EXTERNAL' &&
            !validateUrl(slidesValue?.redirectLink?.linkId)
          ) {
            slidesError = {
              ...slidesError,
              redirect: 'validUrl',
              pos: slidesPos,
            };
          }
          if (
            slidesValue?.redirectLink?.isActive &&
            slidesValue?.redirectLink?.connection === 'EXTERNAL' &&
            !slidesValue?.redirectLink?.linkId
          ) {
            slidesError = {
              ...slidesError,
              redirect: 'required',
              pos: slidesPos,
            };
          }
          if (
            listValue.id === CAROUSEL_SOCIAL &&
            slidesValue.redirectLinkUri &&
            !validateUrl(slidesValue?.redirectLinkUri)
          )
            slidesError = {
              ...slidesError,
              redirectLinkUri: 'validUrl',
              pos: slidesPos,
            };
          if (
            slidesValue?.cta?.isActive &&
            !slidesValue?.cta?.title &&
            (listValue?.id === HERO_BANNER_W_CTA ||
              listValue?.id === HERO_BANNER_W_SUBTITLE_CTA ||
              listValue?.id === CAROUSEL_LANDSCAPE_W_BODY_CTA ||
              listValue?.id === SMALL_BANNER_W_TITLE)
          )
            slidesError = {
              ...slidesError,
              ctaTitle: 'required',
              pos: slidesPos,
            };
          if (Object.keys(slidesError).length > 0) return slidesError;
        });
        const filterSlidesError = slides?.filter((e) => e !== undefined);
        if (filterSlidesError?.length || Object.keys(configError).length > 0)
          return {
            slides: filterSlidesError ?? [],
            pos: listNdx,
            id: listValue.id,
            config: configError,
          };
      }
    });
    const filteredComponentsError = componentsError.filter((e) => e !== undefined);
    setHandleError(filteredComponentsError);
    return filteredComponentsError;
  };

  const savePageBuilder = async (isPublish = false) => {
    const selectedLanguage = decryptLocalStorage('lang');
    const language = selectedLanguage !== 'en' ? selectedLanguage : '';
    if (componentsList.length <= maxCompLimit) {
      const errors = checkComponentField();
      if (errors?.length > 0) {
        const firstErrorComponent = errors[0];

        const newExpandStatus = [...componentExpandStatus];
        newExpandStatus[firstErrorComponent?.pos] = true;
        setComponentExpandStatus(newExpandStatus);
        const errorElement = document?.getElementById(`component-${firstErrorComponent.pos}`);
        if (errorElement) {
          errorElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        notificationManager('danger', 'Please fill all required fields');
        return false;
      }

      const configList = componentsList.map((d) => {
        const obj = { ...d };
        delete obj.uuxid;
        if (
          obj?.id === IMAGE_W_TITLE_BODY ||
          obj?.id === CAROUSEL_PORTRAIT_W_BG ||
          obj?.id === CAROUSEL_LANDSCAPE_W_BG ||
          obj?.id === CAROUSEL_W_DESCRIPTION ||
          obj?.id === CAROUSEL_WO_BG ||
          obj?.id === CAROUSEL_LARGE_IMG_W_BG ||
          obj?.id === CAROUSEL_LANDSCAPE_W_BODY_CTA ||
          obj?.id === HERO_BANNER_W_TITLE ||
          obj?.id === HERO_BANNER_W_CTA ||
          obj?.id === SMALL_BANNER_W_TITLE ||
          obj?.id === HERO_BANNER_W_SUBTITLE_CTA ||
          obj?.id === CAROUSEL_SOCIAL
        ) {
          let tempSLides = obj?.config?.slides.map((slide) => {
            return !slide?.isVideo
              ? {
                  ...slide,
                  videoURL: '',
                  loopPlayBack: false,
                }
              : {
                  ...slide,
                  imgURL: '',
                };
          });
          obj.config.slides = tempSLides;
        } else if (
          obj?.id === IMAGE_LARGE_W_TITLE_BODY ||
          obj?.id === IMAGE_LARGE_W_BG ||
          obj?.id === IMAGE_LARGE ||
          obj?.id === IMAGE_LARGE_W_TITLE_SUBTITLE_BODY
        ) {
          if (obj?.config?.isVideo) {
            obj.config.imgURL = '';
          } else {
            obj.config.videoURL = '';
            obj.config.loopPlayBack = false;
          }
        } else if (obj?.id === SERVICE_DETAIL_COMPONENT) {
          let tempSlides = obj?.config?.images.map((slide) => {
            return !slide?.isVideo
              ? {
                  ...slide,
                  videoURL: '',
                  loopPlayBack: false,
                }
              : {
                  ...slide,
                  imgURL: '',
                };
          });
          obj.config.images = tempSlides;
        } else if (obj?.id === CAROUSEL_LARGE_IMG_W_BG) {
          if (obj?.config?.imgMain?.isVideo) {
            obj.config.imgMain.imgURL = '';
          } else {
            obj.config.imgMain.videoURL = '';
            obj.config.imgMain.loopPlayBack = false;
          }
        }

        return obj;
      });

      try {
        dispatch(stepUpLoaderCount());
        await saveUiBuilderPageConfigs(hotelId, page.id, JSON.stringify(configList), language);
        if (isPublish) {
          await onClickPublish(hotelId, page.id);
        } else {
          dispatch(fetchAllUIBuilderPages(hotelId));
          onViewToggle(null, false, null);
          notificationManager('success', 'Changes saved');
        }
      } catch (error) {
        notificationManager('danger', 'Page components updation failed');
      } finally {
        dispatch(stepDownLoaderCount());
      }
    } else {
      notificationManager('danger', 'Maximum limit of Components reached');
    }
  };

  const onClickPublish = async (hotelId, id) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      await publishUiBuilderPage(hotelId, id, language);
      dispatch(fetchAllUIBuilderPages(hotelId));
      notificationManager('success', 'Page published successfully');
      onViewToggle(null, false, null);
    } catch (error) {
      notificationManager('danger', error?.graphQLErrors?.[0]?.message ?? 'Failed to publish page');
      onViewToggle(null, false, null);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const reorder = (list, sourceIndex, destinationIndex) => {
    const result = [...list];
    const [removed] = result.splice(sourceIndex, 1);
    result.splice(destinationIndex, 0, removed);
    return result;
  };

  const onDragEnd = (dragResult) => {
    if (!dragResult.destination) return;
    const reorderedComponents = reorder(
      componentsList,
      dragResult.source.index,
      dragResult.destination.index,
    );
    const reorderedExpandedStatus = reorder(
      componentExpandStatus,
      dragResult.source.index,
      dragResult.destination.index,
    );
    setComponentsList(reorderedComponents);
    setComponentExpandStatus(reorderedExpandedStatus);
  };

  const toggleExpandedStatus = (expandedStatusArray) => {
    setComponentExpandStatus(expandedStatusArray);
  };

  return (
    <div className='container mt-5 pt-4'>
      {deleteComponent.status === true && (
        <DeletePopupModel
          deletePopUp={deleteComponent}
          onDelete={onClickDelete}
          onDeleteCancel={handleClose}
        />
      )}
      <div className='col-md-12'>
        <div className='col-md-6 px-0 d-flex align-items-center'>
          <Button
            variant='text'
            color='secondary'
            size='small'
            startIcon={<ArrowBack />}
            onClick={(e) => {
              onViewToggle(null, false, null);
            }}
            className='me-2'
          >
            Back
          </Button>
          <span className='page-title'>{page.name}</span>
        </div>
      </div>
      <div className='card page-builder shadow mt-4 mb-4 p-4 '>
        <div className='row justify-content-around'>
          <div className='col-md-9'>
            <div
              onDrop={(e) => onComponentDrop(e)}
              onDragOver={(e) => onComponentragOver(e)}
              className='droppable page-builder-space'
            >
              <div className='page-builder-scroll scroll-styled'>
                {componentsList.length === 0 ? (
                  <div className='d-flex align-items-center justify-content-center h-100'>
                    {'Drag & Drop component here'}
                  </div>
                ) : (
                  <>
                    {componentsList && componentsList.length > 0 && (
                      <>
                        <DragDropContext onDragEnd={(e) => onDragEnd(e)}>
                          <Droppable droppableId='droppable'>
                            {(provided, snapshot) => (
                              <div
                                {...provided.droppableProps}
                                className='col-md-12 px-1 py-3'
                                ref={provided.innerRef}
                              >
                                {componentsList.map((component, componentIndex) => (
                                  <Draggable
                                    key={'dragable' + component?.uuxid}
                                    draggableId={component?.uuxid}
                                    index={componentIndex}
                                    disabled={true}
                                  >
                                    {(provided, snapshot) => (
                                      <div
                                        key={component.uuxid}
                                        id={`component-${componentIndex}`}
                                        className='row d-flex'
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                      >
                                        <div className='d-flex page-builder-component'>
                                          <div className='page-builder-component-item'>
                                            <UiBuilderCommonComponent
                                              groupId={groupId}
                                              component={component}
                                              onItemChange={(e) =>
                                                onComponentChange(e, componentIndex)
                                              }
                                              handleError={handleError}
                                              componentNdx={componentIndex}
                                              componentExpandStatus={componentExpandStatus}
                                              toggleExpandedStatus={toggleExpandedStatus}
                                            />
                                          </div>
                                          <div className='page-builder-component-actions hidden-menu mt-2 ms-4'>
                                            <div
                                              className='pointer'
                                              onClick={() => handleDeletePopupOpen(componentIndex)}
                                            >
                                              <Tooltip title='Remove' placement='bottom-end'>
                                                <DeleteForeverIcon />
                                              </Tooltip>
                                            </div>
                                            <div
                                              className='mt-1 pointer'
                                              onClick={() => onClickDuplicate(component)}
                                            >
                                              <Tooltip title='Duplicate' placement='bottom-end'>
                                                <ContentCopyIcon />
                                              </Tooltip>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                ))}
                                {provided?.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </>
                    )}
                    {isAddLine && (
                      <div className='text-center'>
                        <hr className='add-line' />
                        <AddCircleOutlineIcon className='plus-icon' />
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className='col-md-3 p-0'>
            <div className='page-builder-preview p-2 shadow p-0'>
              <div className='fs-16 text-center'>Preview</div>
              <div className='m-2 page-builder-preview-mobile'>
                <div className='d-flex p-1 justify-content-between'>
                  <div className='page-builder-preview-mobile-time'>9.41</div>
                  <div>
                    <SignalCellularAltIcon className='page-builder-preview-mobile-icon' />
                    <NetworkWifiIcon className='page-builder-preview-mobile-icon' />
                  </div>
                </div>
                <div>
                  <PageBuilderPreview components={componentsList} />
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 p-0 mt-3 d-flex justify-content-end page-builder-custom-button-wrapper'>
            <Button
              variant='contained'
              type='button'
              color='primary'
              className='me-3'
              size='large'
              onClick={() => savePageBuilder(true)}
              disabled={componentsList.length === 0}
            >
              Save & Publish
            </Button>
            <Button
              variant='contained'
              size='large'
              color='primary'
              onClick={() => savePageBuilder(false)}
              disabled={componentsList.length === 0}
            >
              Save as Draft
            </Button>
          </div>
          <div className='col-md-6 p-0 mt-3 d-flex justify-content-end page-builder-custom-button-wrapper page-builder-save-draft-message '>
            <Info fontSize='small' />
            If the page has previously been published, clicking on "Save as Draft" will unpublish it
          </div>
        </div>
      </div>
      <div
        className={
          showLibrary
            ? 'open library-drawer shadow scroll-styled p-3'
            : 'library-drawer shadow  p-3'
        }
      >
        <div className='row align-items-center'>
          <div className='col-md-10'>
            <span className='library-drawer-title'>Library</span>
          </div>
          <div className='col-md-2'>
            <IconButton aria-label='delete' onClick={() => setShowLibrary(false)}>
              <CancelIcon className='library-drawer-cancel' />
            </IconButton>
          </div>
        </div>
        <PageBuilderLibrary components={componentsList} setIsAddLine={setIsAddLine} />
      </div>
      {!showLibrary && (
        <div className='library-toggle'>
          <Button
            onClick={() => setShowLibrary(true)}
            variant='contained'
            type='submit'
            color='primary'
            className='library-toggle-btn me-3'
            size='large'
          >
            <AddBoxOutlinedIcon style={{ color: 'white' }} />
          </Button>
        </div>
      )}
    </div>
  );
};

export default UiBuilderPageBuilder;
